/**
 * `liveRefetchOptions` — the "someone else changed this while I was
 * looking at it" refetch policy, shared by the post-publish lead reads.
 *
 * Backlog #90 (checklist 05.05 / 05.24). `main.tsx` sets
 * `refetchOnWindowFocus: false` on the global QueryClient, which is the
 * right default for the planning surfaces (a lead tabbing away and back
 * should not lose their place to a refetch storm). It is the WRONG default
 * for the live-roster reads: a member reporting off sick — or withdrawing
 * it — from their phone changed nothing in an already-open lead window. No
 * `OFF SICK` strike, no `Review cover · 1` chip, until a manual reload.
 *
 * So the handful of queries that carry "what is true on the roster right
 * now" opt back IN, per query, never globally:
 *
 *   * `refetchOnWindowFocus: true` — the lead comes back to the tab after
 *     the phone call and the window is current.
 *   * `refetchInterval: 30s` — the lead who never leaves the tab (grid on
 *     one screen, phone in hand) still sees the report land.
 *   * `refetchIntervalInBackground: false` — the timer only runs while the
 *     tab is focused, so a parked window costs nothing.
 *
 * Deliberately NOT applied to the planning / config reads: only the roster
 * grid, the "Review cover" attention feed, the call-back ladder, the
 * coverage review and the swaps board (behind the `Swaps · N` chip) speak
 * about the published day.
 */

/** 30s — fast enough that a phoned-in MC lands inside the conversation. */
export const LIVE_REFETCH_INTERVAL_MS = 30_000;

export const liveRefetchOptions = {
  refetchOnWindowFocus: true,
  refetchInterval: LIVE_REFETCH_INTERVAL_MS,
  refetchIntervalInBackground: false,
} as const;
